<template>
    <v-layout>
        <v-flex>
            <v-card v-if="!newPasswordSaved">
              <v-card-title class="white--text tertiary">
                <h1>Change Your Password</h1>
              </v-card-title>
              <v-card-text>
                <h2 v-if="email">Password Reset For <b>{{ email }}</b></h2>
                <p>You've requested a password reset, don't worry it happens, passwords get forgotten but your new password will be better. And maybe later, it'll be forgotten as well.</p>
                <v-text-field
                    v-model="newPassword"
                    label="New Password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="[passwordRules.required, checkPassword]"
                    @click:append="showPassword = !showPassword"
                    required
                ></v-text-field>
                <v-text-field
                    v-model="newPasswordConfirm"
                    label="Confirm New Password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    :rules="[passwordRules.required, checkPassword]"
                    @click:append="showPassword = !showPassword"
                    required
                ></v-text-field>
                <p class="red--text">If you did not request this password reset, please contact support at customerportal@danielshealth.ca</p>
              </v-card-text>
              <v-card-actions v-if="token">
                  <v-spacer></v-spacer>
                  <v-btn class="white--text accent" @click="updateUserPassword">
                      Save New Password
                  </v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-else>
                <v-card-title>
                    Password Successfully Reset
                </v-card-title>
                <v-card-text>
                    <p>Your new password has been saved! You will be redirected to the portal in 10 seconds.</p>
                    <p>Otherwise, you can close this window/tab.</p>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>    
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

export default {
    name: 'PasswordReset',
    props: {
        email: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        }, 
        token: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            newPassword: null,
            newPasswordConfirm: null,
            newPasswordSaved: false,
            feedback: null,     
            showPassword: false,
            passwordRules: { required: v => !!v || "Password is required" }
        }
    },
    methods: {
        updateUserPassword: function() {
            firebase.auth().confirmPasswordReset(this.token, this.newPasswordConfirm).then(() => {
                this.newPasswordSaved = true;
                setTimeout( this.login, 10000); // sign in user after 10 seconds
            }).catch(confirmPasswordError => {
                this.$emit("authResponse", confirmPasswordError);
                console.log(confirmPasswordError);
            });
        },
        checkPassword: function () {
            if (this.newPasswordConfirm && this.newPassword !== this.newPasswordConfirm) {
                return "Passwords do not match."
            } else {
                return true;
            }
        },
        login: function () {
            firebase.auth().signInWithEmailAndPassword(this.email, this.newPasswordConfirm)
            .then(cred => {
                this.$router.push({ name: 'home' });
            }).catch(err => {
                this.$emit("authResponse", err);
                console.log(err);
            });
        }
    },
    mounted() {
        
    }
}
</script>

<style scoped>

</style>